var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35127393-4ED6-4340-B068-6A932937F61D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -189.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4583228,7.46154332 C12.1591577,7.46154332 11.9166455,7.70262072 11.9166455,8.00001578 L11.9166455,13.3846142 C11.9166455,13.6820092 11.6741333,13.9230866 11.3749683,13.9230866 L1.625,13.9230866 C1.32583496,13.9230866 1.08332275,13.6820092 1.08332275,13.3846142 L1.08332275,2.61538583 C1.08332275,2.31799077 1.32583496,2.07691337 1.625,2.07691337 L8.125,2.07691337 C8.42416504,2.07691337 8.66667725,1.83583596 8.66667725,1.53844091 C8.66667725,1.24104585 8.42416504,1 8.125,1 L1.625,1 C0.727536621,1 0,1.72323221 0,2.61538583 L0,13.3846142 C0,14.2767678 0.727536621,15 1.625,15 L11.375,15 C12.2724634,15 13,14.2767678 13,13.3846142 L13,7.99998422 C13,7.70262072 12.7574878,7.46154332 12.4583228,7.46154332 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3885576,0.611664105 C13.9969148,0.219959146 13.465701,0 12.9117952,0 C12.3575699,-0.00158938342 11.8258128,0.218808577 11.4352566,0.612015668 L4.25046248,7.79617099 C4.19085633,7.85622432 4.14588805,7.92922155 4.11900935,8.00944181 L3.02810496,11.2821725 C2.93289493,11.5679932 3.08742347,11.8768571 3.37324534,11.9720348 C3.42869664,11.9905078 3.48676869,12 3.5451923,12 C3.60374376,12 3.66194365,11.9905078 3.71755475,11.9721946 L6.99029987,10.881295 C7.07068028,10.8544484 7.1437098,10.8092566 7.20357163,10.7492991 L14.3883338,3.5645685 C15.2038035,2.74919832 15.2038994,1.42713017 14.3885576,0.611664105 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.84ec32a32b098b989a498e8684c22e92.svg";
export { ForwardRef as ReactComponent };